import { render } from "./my_practices.vue?vue&type=template&id=5614c78c"
import script from "./my_practices.vue?vue&type=script&lang=js"
export * from "./my_practices.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__